// components
import { styled, Stack, StackProps } from '@mui/material';

export const StyledRowStackAlignItemsSpaceBetweenGap = styled(
  Stack
)<StackProps>(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: theme.spacing(4)
}));

export const StyledRowStackSmallGap = styled(Stack)<StackProps>(
  ({ theme }) => ({
    flexDirection: 'row',
    gap: theme.spacing(2)
  })
);

export const StyledRowStackGap = styled(Stack)<StackProps>(({ theme }) => ({
  flexDirection: 'row',
  gap: theme.spacing(4)
}));

export const StyledRowStackAlignItemsAltGap = styled(Stack)<StackProps>(
  ({ theme }) => ({
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(3)
  })
);

export const StyledRowStackAlignItemsGap = styled(Stack)<StackProps>(
  ({ theme }) => ({
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(4)
  })
);

export const StyledRowStackAlignItemsSmallGap = styled(Stack)<StackProps>(
  ({ theme }) => ({
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(2)
  })
);

export const StyledStackSpaceBetweenFullHeight = styled(Stack)<StackProps>(
  () => ({
    justifyContent: 'space-between',
    height: '100%'
  })
);

export const StyledRowStackStartSpaceBetweenSmallGap = styled(
  Stack
)<StackProps>(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  gap: theme.spacing(2)
}));
